module.exports = __webpack_public_path__ + "static/media/6.ba43978c.JPG";